import script from "./HeaderNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNotification.vue?vue&type=style&index=0&id=1559761c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1559761c"]])

export default __exports__